import { UserRole } from '@mairistem/finances-utils';
import TypeLigneMontant from '../../constants/simulation/typeLigneMontant';
import TypePeriode, {
	LIBELLES_PERIODE,
} from '../../constants/simulation/typePeriode';
import type MontantSimulation from '../../interfaces/simulation/montantSimulation';

// Regles de vie d'une demande creee par l'import d'une idee Vision 360 : statut
// et demande figes, duplication interdite, suppression selon periode et role

export const estIssueDIdee = (montantSimulation: MontantSimulation) =>
	montantSimulation.type === TypeLigneMontant.IDEATION;

export const MOTIF_DUPLICATION_IDEE =
	"Une demande issue d'une idée ne peut pas être dupliquée : l'idée n'est liée qu'à une seule demande.";

// Motif affiche dans le menu d'actions quand la suppression est refusee, null
// si elle est possible. Un proposé different du demande signifie qu'un pilote a
// retraite la demande : le gestionnaire ne peut plus la supprimer, pour ne pas
// contourner l'arbitrage en la reimportant
export const getMotifSuppressionIdee = (
	montantSimulation: MontantSimulation,
	typePeriode: TypePeriode,
	userRole: UserRole,
): string | null => {
	if (userRole >= UserRole.CHARGE_PILOTAGE) return null;
	if (typePeriode !== TypePeriode.DEMANDE) {
		return `Réservé aux administrateurs et chargés du pilotage budgétaire en période ${LIBELLES_PERIODE[typePeriode]}.`;
	}
	return (montantSimulation.prop ?? 0) === (montantSimulation.demande ?? 0)
		? null
		: 'Suppression impossible car le montant proposé a été modifié.';
};
